"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var QueryError_1 = require("./errors/QueryError");
exports.createClient = function (clientOptions) {
    var cache = clientOptions.cacheProvider;
    var handleRequestInterceptors = function (action, interceptors) { return __awaiter(_this, void 0, void 0, function () {
        var interceptor, next, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    interceptor = interceptors[0], next = interceptors.slice(1);
                    if (!interceptor) return [3 /*break*/, 3];
                    _b = handleRequestInterceptors;
                    return [4 /*yield*/, interceptor(client)(action)];
                case 1: return [4 /*yield*/, _b.apply(void 0, [_c.sent(), next])];
                case 2:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = action;
                    _c.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    }); };
    var handleResponseInterceptors = function (action, response, interceptors) { return __awaiter(_this, void 0, void 0, function () {
        var interceptor, next, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    interceptor = interceptors[0], next = interceptors.slice(1);
                    if (!interceptor) return [3 /*break*/, 3];
                    _b = handleResponseInterceptors;
                    _c = [action];
                    return [4 /*yield*/, interceptor(client)(action, response)];
                case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), next]))];
                case 2:
                    _a = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = response;
                    _d.label = 4;
                case 4: return [2 /*return*/, _a];
            }
        });
    }); };
    var client = {
        cache: cache,
        query: function (actionInit, skipCache) {
            if (skipCache === void 0) { skipCache = false; }
            return __awaiter(_this, void 0, void 0, function () {
                var action, endpoint, body, responseType, options, cachedResponse, headers, shouldStringify, fetchFunction, response, queryResponse, _a, _b, _c, error_1;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 5, , 6]);
                            return [4 /*yield*/, handleRequestInterceptors(actionInit, clientOptions.requestInterceptors || [])];
                        case 1:
                            action = _d.sent();
                            endpoint = action.endpoint, body = action.body, responseType = action.responseType, options = __rest(action, ["endpoint", "body", "responseType"]);
                            if (cache && !skipCache) {
                                cachedResponse = cache.get(actionInit);
                                if (cachedResponse) {
                                    return [2 /*return*/, cachedResponse];
                                }
                            }
                            headers = __assign({ 'Content-Type': 'application/json; charset=utf-8' }, options.headers);
                            shouldStringify = headers['Content-Type'].indexOf('json') !== -1;
                            fetchFunction = clientOptions.fetch || fetch;
                            return [4 /*yield*/, fetchFunction(endpoint, {
                                    body: body ? (shouldStringify ? JSON.stringify(body) : body) : undefined,
                                    cache: options.cache,
                                    credentials: options.credentials,
                                    headers: headers,
                                    integrity: options.integrity,
                                    keepalive: options.keepalive,
                                    method: options.method,
                                    mode: options.mode,
                                    redirect: options.redirect,
                                    referrer: options.referrer,
                                    referrerPolicy: options.referrerPolicy,
                                    signal: options.signal,
                                    window: options.window,
                                })];
                        case 2:
                            response = _d.sent();
                            _a = handleResponseInterceptors;
                            _b = [action];
                            _c = {
                                error: !response.ok,
                                headers: response.headers
                            };
                            return [4 /*yield*/, resolveResponse(response, responseType)];
                        case 3: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_c.payload = _d.sent(),
                                    _c.status = response.status,
                                    _c), clientOptions.responseInterceptors || []]))];
                        case 4:
                            queryResponse = _d.sent();
                            if (cache && response.ok) {
                                cache.add(actionInit, queryResponse);
                            }
                            if (queryResponse.status &&
                                action.config &&
                                action.config.emitErrorForStatuses &&
                                action.config.emitErrorForStatuses.includes(queryResponse.status)) {
                                throw new QueryError_1.QueryError('request-error', queryResponse);
                            }
                            return [2 /*return*/, queryResponse];
                        case 5:
                            error_1 = _d.sent();
                            return [2 /*return*/, {
                                    error: true,
                                    errorObject: error_1,
                                }];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
    };
    return client;
};
function resolveResponse(response, responseType) {
    return __awaiter(this, void 0, void 0, function () {
        var emptyCodes, contentType, isJSON, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!responseType) return [3 /*break*/, 1];
                    return [2 /*return*/, response[responseType]()];
                case 1:
                    emptyCodes = [204, 205];
                    contentType = response.headers.get('Content-Type');
                    isJSON = emptyCodes.indexOf(response.status) === -1 && contentType && contentType.indexOf('json') !== -1;
                    if (!isJSON) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, response.text()];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5: return [2 /*return*/, _a];
            }
        });
    });
}
